import { useContext, useEffect, useState, useRef } from "react";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";

import ImageGallery, { ReactImageGalleryItem } from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

import LegitCheckService from "../../services/legitCheckService";
import RenderService from "../../services/renderService";
import FormatService from "../../services/formatService";

import { Shirt } from "../../entities/Shirt";
import DialogService from "../Dialog/dialogService";
import NewMessage from "../NewMessage/NewMessage";
import NewLegitCheck from "../NewLegitCheck/NewLegitCheck";
import LegitCheckResults from "../LegitCheckResults/LegitCheckResults";
import PremiumWrapperButton from "../PremiumWrapperButton/PremiumWrapperButton";
import JoinPremiumPopUpNew from "../JoinPremiumPopUpNew/JoinPremiumPopUpNew";
import LinkWrapper from "../LinkWrapper/LinkWrapper";

import { LegitCheckItem } from "../../types/types";
import { Actions, Subjects } from "../../permission/constants";
import { AbilityContext } from "../../permission/Can";

import "./ShirtDetailView.css";
import ReactImageGallery from "react-image-gallery";
import ImageDetail from "../ImageDetail/ImageDetail";

interface ShirtDetailViewProps {
  shirt: Shirt;
}

const ShirtDetailView = ({ shirt }: ShirtDetailViewProps) => {
  const [lcResults, setLcResults] = useState<Array<LegitCheckItem> | undefined>(
    undefined
  );
  const [positiveChecks, setPositiveChecks] = useState<number | undefined>(
    undefined
  );
  const [legitChecked, setLegitChecked] = useState<boolean>(false);
  const [imgList, setImgList] = useState<ReactImageGalleryItem[]>();

  const { RenderShirt } = RenderService();
  const { openSM, openMD, open } = DialogService();
  const ability = useContext(AbilityContext);
  const { getLegitChecks } = LegitCheckService();
  const { getMoneyFormat } = FormatService();

  const imgGallery = useRef<ReactImageGallery | null>(null);

  const isMobile = useMediaQuery("(max-width:600px)");

  const irresistibleOffer = () => {
    if (shirt?.owner) {
      openSM(
        "Place an irresistible offer",
        <NewMessage
          isOffer={true}
          targetUser={shirt.owner.id}
          shirtName={shirt.title}
        />,
        []
      );
    }
  };

  const legitCheck = () => {
    if (shirt?.id) {
      const puTitle = "Only VIPs can perform Legit Checks";
      const puText =
        "Legit Checks are reserved for serious collectors. As a VIP, you can help verify the authenticity of other collectors' shirts and contribute to the community. Upgrade to become a trusted voice in the Collecticos community and access exclusive tools.";
      ability.can(Actions.DO, Subjects.LEGIT_CHECK)
        ? openSM(
            "You think this shirt is Legit or not Legit",
            <NewLegitCheck
              itemId={shirt.id}
              setLegitChecked={setLegitChecked}
            />,
            []
          )
        : openSM("", <JoinPremiumPopUpNew title={puTitle} text={puText} />, []);
    }
  };

  const legitCheckResults = () => {
    if (shirt?.id) {
      openMD(
        "Legit Check Results",
        <LegitCheckResults itemId={shirt.id} legitChecks={lcResults} />,
        []
      );
    }
  };

  useEffect(() => {
    console.log({ shirt });
    if (shirt?.id && ability.can(Actions.VIEW, Subjects.LEGIT_CHECK)) {
      getLegitChecks(shirt.id).then((results) => {
        if (results) {
          const isLegitResults = results.filter((item) => item.is_legit).length;
          setLcResults(results);
          setPositiveChecks(isLegitResults);
        }
      });
    }

    if (shirt.images.length > 0) {
      const temp = shirt.images.map((item) => {
        return {
          original: item.url,
          thumbnail: item.url,
          originalClass: "img-gallery-item",
        };
      });
      setImgList(temp);
    }
  }, [shirt]);

  useEffect(() => {
    if (legitChecked === true) {
      if (shirt?.id && ability.can(Actions.VIEW, Subjects.LEGIT_CHECK)) {
        getLegitChecks(shirt.id).then((results) => {
          if (results) {
            const isLegitResults = results.filter(
              (item) => item.is_legit
            ).length;
            setLcResults(results);
            setPositiveChecks(isLegitResults);
          }
        });
      }
    }
  }, [legitChecked]);

  //TODO: Change purchase_price for estimated price
  return (
    <Box
      sx={{
        padding: { xs: 0, md: "0rem 2rem 2rem 2rem" },
        display: { xs: "block", md: "flex" },
      }}
      aria-label="ShritDetailView-Container"
    >
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          paddingRight: { xs: "0px", md: "1rem" },
        }}
      >
        {imgList && imgList.length > 0 && (
          <Box
            sx={{
              position: "relative",
              marginBottom: "1rem",
              paddingBottom: "1rem",
            }}
            aria-label="Carousel-Container"
          >
            <ImageGallery
              ref={imgGallery}
              items={imgList}
              showPlayButton={false}
              showFullscreenButton={false}
              showThumbnails={true}
              thumbnailPosition={isMobile ? "right" : "bottom"}
              showNav={false}
              onClick={() => {
                if (imgGallery.current) {
                  open(
                    "",
                    <ImageDetail
                      imageUrl={
                        imgList[imgGallery.current.getCurrentIndex()].original
                      }
                    />,
                    []
                  );
                }
              }}
            />
          </Box>
        )}
      </Box>

      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          paddingLeft: { xs: "0px", md: "2rem" },
        }}
      >
        <Box sx={{ marginBottom: "0.5rem" }}>
          <Typography
            sx={{
              fontSize: "1.2rem !important",
              fontWeight: 600,
              fontStyle: "italic",
            }}
          >
            {shirt.title}
          </Typography>
        </Box>
        {/* {shirt.current_price === -1 ? (
          <PremiumWrapperButton
            action={Actions.VIEW_CURRENT_VALUE}
            entity={Subjects.COLLECTION}
            text="Current Value"
            component={
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontSize: "1.2rem",
                      fontWeight: 600,
                      fontStyle: "italic",
                    }}
                  >
                    Current Value
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    variant="shirtViewTitle"
                    sx={{
                      fontSize: "1.75rem !important",
                      color: "#4663ff !important",
                    }}
                  >
                    {getMoneyFormat(shirt.current_price)}
                  </Typography>
                </Box>
              </Box>
            }
          />
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: "1.2rem",
                  fontWeight: 600,
                  fontStyle: "italic",
                }}
              >
                Current Value
              </Typography>
            </Box>
            <Box>
              <Typography
                variant="shirtViewTitle"
                sx={{
                  fontSize: "1.75rem !important",
                  color: "#4663ff !important",
                }}
              >
                {getMoneyFormat(shirt.current_price)}
              </Typography>
            </Box>
          </Box>
        )} */}

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "1rem",
          }}
        >
          <LinkWrapper
            visitorUrl="/sign-up"
            freeUserUrl=""
            premiumUserUrl=""
            closeOnVisitor={true}
            closeOnSigned={false}
            clickFunction={irresistibleOffer}
            component={
              <Typography
                sx={{
                  textTransform: "uppercase",
                  fontSize: "14px",
                  fontStyle: "italic",
                  fontWeight: "bold",
                  display: "block",
                  width: { xs: "fit-content", md: "190px" },
                  textAlign: "center",
                }}
              >
                <a
                  className="btn-gradient move-right"
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  Irresistible Offer
                </a>
              </Typography>
            }
          />
          <LinkWrapper
            visitorUrl="/sign-up"
            freeUserUrl=""
            premiumUserUrl=""
            closeOnVisitor={true}
            closeOnSigned={false}
            clickFunction={legitCheck}
            component={
              <Typography
                sx={{
                  textTransform: "uppercase",
                  fontSize: "14px",
                  fontStyle: "italic",
                  fontWeight: "bold",
                  width: { xs: "fit-content", md: "150px" },
                  textAlign: "center",
                }}
              >
                <a
                  className="btn-gradient move-right"
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  Legit Check
                </a>
              </Typography>
            }
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          {ability.can(Actions.VIEW, Subjects.LEGIT_CHECK) && (
            <Button
              variant="text"
              sx={{
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                fontFamily: "Manrope",
              }}
              onClick={legitCheckResults}
            >
              LC ({positiveChecks ? positiveChecks : "0"}/
              {lcResults ? lcResults.length : "0"})
            </Button>
          )}
        </Box>

        <Box sx={{ marginTop: "2rem" }}>{RenderShirt(shirt)}</Box>
      </Box>
    </Box>
  );
};

export default ShirtDetailView;
